import StructureOverviewPanel from "./structureOverviewPanel.container";

export default StructureOverviewPanel;
